import { register } from './index.js';

register();
